import * as React from 'react';
import clsx from 'clsx';
import { Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import countries from '../../../public/static/countries.json';
import { getCountrySpecificConfig } from '../../helpers/helpInfo';

export const TYPE = 'mui-phone-input';

export class MuiPhoneInputModel extends Question {
  getType(): string {
    return TYPE;
  }
}

export class MuiPhoneInput extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  get question() {
    return this.questionBase;
  }

  handleChange(value: string, data: CountryData, _: React.ChangeEvent<HTMLInputElement>, formattedValue: string) {
    this.question.value = formattedValue;
    this.question.setPropertyValue('invalidCountry', !value.startsWith(data.dialCode));
  }

  handleFocus() {
    this.question.setPropertyValue('focused', true);
  }

  handleBlur() {
    this.question.setPropertyValue('focused', false);
  }

  protected renderElement(): JSX.Element | null {
    const { value = '', title, isRequired } = this.question;
    const focused = this.question.getPropertyValue('focused');
    const hideFlag = this.question.getPropertyValue('invalidCountry');
    const { country } = getCountrySpecificConfig();
    const getCountry = () => {
      return (country === 'GB' || country === 'AU' ? country : 'GB').toLowerCase();
    };

    return (
      <fieldset className={clsx(focused && 'focused')}>
        <legend>
          {title}
          {isRequired ? ' *' : ''}
        </legend>
        <PhoneInput
          onlyCountries={countries.map(countryData => countryData.iso2.toLowerCase())}
          country={getCountry()}
          inputProps={{
            required: isRequired,
            tabIndex: 1
          }}
          value={value}
          onChange={this.handleChange}
          specialLabel=""
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          buttonClass={hideFlag ? 'hide-flag' : ''}
          dropdownClass={'drop-down'}
          enableLongNumbers
        />
      </fieldset>
    );
  }
}
